/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Box, CardContent, Card, CardMedia, CardActions, Button } from '@mui/material';

import { setLastRequestTime } from "../../Utils";


function handleClick(url, e) {
    e.preventDefault();
    setLastRequestTime();
    if (url === 'subscribed') {
        console.log('clicked subscribed')
        document.getElementById("insights-lead-open-form").click();
    } else if (url.includes('tel')) {
        window.open(url);
    }
    else {
        window.open(url, '_blank');
    }
}

export default function MediaCard(props) {


    return (
        <Card 
         id={`card-${props.id}`}
         sx={{
             
             height: '100%',
             display: 'flex',
             flexDirection: 'column',
             justifyContent: 'space-between',
             boxShadow: '0px 0px 8px rgba(59, 59, 59, 0.12), 0px 6px 4px rgba(59, 59, 59, 0.05), 0px 3px 3px rgba(59, 59, 59, 0.05)',
             '&:hover': {
                 boxShadow: '0px 2px 15px rgba(59, 59, 59, 0.1), 0px 10px 15px rgba(0, 0, 0, 0.12), 0px 4px 3px rgba(0, 0, 0, 0.04)',
             },
          }}
        >

            <CardMedia
                sx={{
                    width: '55px',
                    height: '55px',
                    marginTop: '32px',
                    marginLeft: '32px',
                }}
                id={`card-image-${props.id}`}
                alt={props.id}
                aria-label={`card-image-${props.id}`}
                image={props.image}
            />
            <CardContent sx={{ margin: '0 16px' }} className='beacon-theme-modern-outlook'>
                <Box
                    className='b-typography-serif--headline--100'
                    sx={{ color: '#000'}}
                    id={`card-title-${props.id}`}
                    pb='8px'
                    dangerouslySetInnerHTML={{
                        __html:
                            props.title,
                    }}
                />
                <Box
                    className='b-typography-sans-serif--body--100'
                    id={`card-content-${props.id}`}

                >
                    {props.text}
                </Box>
            </CardContent>
            <CardActions sx={{ padding: '8px 32px 0 32px' }}>
                <Button
                    disableRipple
                    sx={{
                        position: 'relative',
                        marginBottom: '32px',
                        textTransform: 'none',
                        backgroundColor: props.variant === 'contained' ? '#0063AD' : '#FFFFFF',
                        color: props.variant === 'outlined' && '#0063AD',
                        border: props.variant === 'outlined' && 'solid 1px #0063AD',
                        borderRadius: '4px',
                        width:'100%',
                        height: '48px',
                        gridColumn: 1,
                        gridRow: 1,
                        "&:hover": {
                            backgroundColor: props.variant === 'contained' ? '#0063AD' : '#FFFFFF',
                        },
                        boxShadow: 'none',
                    }}
                    id={`card-button-${props.id}`}
                    variant={props.variant}
                    color="primary"
                    onClick={(e) => handleClick(props.url, e)}
                    data-metrics-location="CTA"
                >
                    {props.buttonText}
                </Button>
            </CardActions>
        </Card>
    );
}
